/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

'use client';

import { useEffect } from 'react';
import { setAnalyticsUserProperties } from '../config/analytics';

/** Push GA user properties as they resolve; undefined values are skipped. */
export const useAnalyticsUserProperties = (
  properties: Record<string, string | boolean | undefined>,
) => {
  // Serialised so an inline object literal does not re-fire every render.
  const serialised = JSON.stringify(properties);

  useEffect(() => {
    const resolved = Object.entries(
      JSON.parse(serialised) as Record<string, string | boolean | undefined>,
    ).reduce<Record<string, string>>((acc, [key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        acc[key] = String(value);
      }
      return acc;
    }, {});

    if (Object.keys(resolved).length === 0) return;
    void setAnalyticsUserProperties(resolved);
  }, [serialised]);
};
